import ServiceBase from "base/baseService"

export default class ListaCestNcmService extends ServiceBase {

    title = "Lista de CEST/NCM"
    pluralTitle = "Listas de CEST/NCM"
    url = '/cadastro/fiscal/listacestncm'
    frontUrl = '/cadastro/fiscal/listacestncm'
    frontUrlList = '/cadastro/fiscal/listacestncmlist'
    primaryKey = 'codigo_lcn'
    ignoredsSchemaConvertions = ['usu_atua_lcn', 'cod_lcn_lcni', 'cod_tlcn_lcn']

    prepareToFront(data = {}) {

        data.descricao_lcn = data?.descricao_lcn || ''

        return data
    }

    prepareToSave({ data }) {
        return data
    }

    getNewListaCestNcmItem(data = {}) {
        return {
            action: 'ins',
            ncm_lcni: '',
            cest_lcni: '',
            ...data
        }
    }

    getNcmWider(list = [], ncm = '') {

        if (!ncm?.trim()) return null

        const wider = list.find(item => {
            const current = item?.ncm_lcni?.trim()
            if (!current) return false
            return ncm.length >= current.length && ncm.startsWith(current)
        })

        return wider?.ncm_lcni?.trim() || null
    }

}
